<template>
	<div>
		<v-breadcrumbs style="font-weight: 600" :items="localizedBreadcrumbs" divider=">"></v-breadcrumbs>

		<v-card class="ma-3">
			<v-card-title>
				<div class="d-flex justify-space-between">
					<div class="d-flex">
						<v-icon color="#FF7E87">mdi-account-circle</v-icon>
						<div class="mx-2">{{ $t('customer_information') }}</div>
					</div>
					<div>
						<v-menu>
							<template v-slot:activator="{ props }">
								<v-icon class="mdi-dots-horizontal" size="large"
									v-bind="props">mdi-dots-horizontal</v-icon>
							</template>
							<v-list class="mt-2" rounded="xl" style="cursor: pointer" elevation="1">
								<v-list-item>
									<v-list-item-title>
										<div class="d-flex mx-3 mb-2 mt-1" @click="isEditProfileOpen = true">
											<div>
												<v-icon>mdi-pencil</v-icon>
											</div>
											<div class="ml-2">{{ $t('edit') }}</div>
										</div>
									</v-list-item-title>
									<v-list-item-title>
										<div class="d-flex mx-3 mt-1 mb-1" style="
												color: rgba(255, 126, 135, 1);
											">
											<div>
												<v-icon>mdi-trash-can-outline</v-icon>
											</div>
											<div class="ml-2">{{ $t('delete') }}</div>
										</div>
									</v-list-item-title>
								</v-list-item>
							</v-list>
						</v-menu>
					</div>
				</div>
			</v-card-title>
			<v-card-text>
				<div>
					<div class="d-flex mt-5">
						<div class="mx-3" style="
								display: flex;
								align-items: center;
								justify-content: center;
							">
							<v-avatar color="grey" size="130" class="ml-5" :image="customerDetail?.pictureUrl">
							</v-avatar>
						</div>
						<div class="mr-5" style="
								color: black;
								font-size: 16px;
								font-family: Roboto;
								font-weight: 400;
								line-height: 30px;
								word-wrap: break-word;
							">
							<div>{{ $t('name') }}: {{ customerDetail.name }}</div>
							<div>
								{{ $t('contact_number') }}: {{ customerDetail.phone }}
							</div>
							<div>{{ $t('email') }}: {{ customerDetail.email }}</div>
							<div>
								{{ $t('register_date') }}: {{ customerDetail.updatedAt }}
							</div>
						</div>
					</div>
					<div class="mx-3 my-5">
						<div class="d-flex justify-space-between my-2">
							<div style="font-weight: 600; font-size: 20px">
								{{ $t('working_history') }}
							</div>
							<div style="cursor: pointer" @click="isCustomerPopupOpen = true">
								{{ $t('see_all') }} >
							</div>
						</div>
						<div v-if="customerIncidents.length">
							<div v-for="(
									customerHistory, index
								) in recentCustomerHistories" :key="index" class="pa-1">
								<div v-if="customerHistory">
									<div style="
											border: 1px solid #dddddd;
											padding: 10px;
											border-radius: 15px;
											margin: 4px;
											font-family: Roboto;
										">
										<div class="text-subtitle-1 font-weight">
											{{ customerHistory.title }}
										</div>
										<div class="text-grey-darken-2">
											Assigned Agent:
											{{
												customerHistory.applications &&
													customerHistory.applications
														.length > 0
													? getAssignedAgent(
														customerHistory
													)?.firstName +
													' ' +
													getAssignedAgent(
														customerHistory
													)?.lastName
													: 'N/A'
											}}
										</div>
										<div class="d-flex justify-space-between">
											<div class="text-grey-darken-2 my-1">
												{{
													formatDate(
														customerHistory.updatedAt
													)
												}}
											</div>
											<div class="d-flex align-center">
												<div>
													<v-rating v-if="
														customerHistory.agentFeedbacks &&
														customerHistory
															.agentFeedbacks
															.length > 0
													" :model-value="customerHistory
														.agentFeedbacks[0]
														?.overallRating
														" size="small" density="compact" color="#FBC816" readonly></v-rating>
													<span v-else>{{ $t('no_rating') }}</span>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</v-card-text>
		</v-card>
		<v-dialog v-model="isCustomerPopupOpen" width="700">
			<v-card rounded="xl">
				<v-card-header class="bg-black">
					<div class="d-flex justify-space-between ma-5">
						<div>Incident history</div>
						<div @click="isCustomerPopupOpen = false">
							<v-icon>mdi-close</v-icon>
						</div>
					</div>
				</v-card-header>
				<v-card-title><v-row align="center my-1">
						<v-col cols="">
							<div style="font-size: 20px; font-weight: 600">
								Incidents ({{ customerIncidents.length }})
							</div>
						</v-col>

						<v-col>
							<div class="search-bar">
								<v-text-field variant="outlined" rounded density="compact"
									prepend-inner-icon="mdi-magnify" placeholder="ค้นหา incident..." hide-details="" />
							</div>
						</v-col> </v-row></v-card-title>
				<v-card-text>
					<div v-if="customerIncidents.length">
						<div v-for="(
								customerHistory, index
							) in paginatedStatusHistories" :key="index" class="pa-1">
							<div v-if="customerHistory">
								<div style="
										border: 1px solid #dddddd;
										padding: 10px;
										border-radius: 15px;
										margin: 4px;
										font-family: Roboto;
									">
									<div class="text-subtitle-1 font-weight">
										{{ customerHistory.title }}
									</div>
									<div class="text-grey-darken-2">
										Assigned Agent:

										{{
											customerHistory.applications &&
												customerHistory.applications
													.length > 0
												? getAssignedAgent(
													customerHistory
												).firstName +
												' ' +
												getAssignedAgent(
													customerHistory
												).lastName
												: 'N/A'
										}}
									</div>
									<div class="d-flex justify-space-between">
										<div class="text-grey-darken-2 my-1">
											{{
												formatDate(
													customerHistory.updatedAt
												)
											}}
										</div>
										<div class="d-flex align-center">
											<div>
												<v-rating v-if="
													customerHistory.agentFeedbacks &&
													customerHistory
														.agentFeedbacks
														.length > 0
												" :model-value="customerHistory
													.agentFeedbacks[0]
													.overallRating
													" size="small" density="compact" color="#FBC816" readonly></v-rating>
												<span v-else>No rating</span>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<v-pagination v-model="currentPage" :length="totalStatusPage" circle></v-pagination>
					</div>
					<div v-else>No customer incidents available.</div>
				</v-card-text>
			</v-card>
		</v-dialog>
		<v-dialog v-model="isEditProfileOpen" width="750">
			<edit-profile :customer-detail="customerDetail" @closeDialog="isEditProfileOpen = false"
				@emit-update-customer-profile="updateCustomerProfile" />
		</v-dialog>
		<v-snackbar v-model="snackbar" :timeout="5000" rounded="pill" color="#8EEDB3" width="500px">
			<div class="d-flex mx-2">
				<v-icon>mdi-check</v-icon>
				<p class="mx-2">Profile has been saved .</p>
			</div>
			<template v-slot:actions>
				<div class="mx-2">
					<v-icon color="black" @click="snackbar = false">
						mdi-close
					</v-icon>
				</div>
			</template>
		</v-snackbar>
	</div>
</template>

<script>
import moment from 'moment'
import EditCustomerProfile from '@/components/EditCustomerProfile.vue'
import customerInfo from '@/services/API/customerInfo.js'
export default {
	components: {
		'edit-profile': EditCustomerProfile,
	},
	data: () => ({
		customerDetail: {},
		customerIncidents: [],
		isCustomerPopupOpen: false,
		isEditProfileOpen: false,
		snackbar: false,
		currentPage: 1,
		itemsPerPage: 5,
		create_incident: [
			{
				title: 'Customer List',
				disabled: false,
				href: '/customer-list',
			},
			{
				title: 'Customer information',
				disabled: true,
				href: 'breadcrumbs_link_1',
			},
		],
	}),
	created() {
		this.singleCustomerList(this.$route.query.customerId)
	},
	computed: {
		localizedBreadcrumbs() {
			return [
				{ title: this.$t('customer_list'), disabled: false, color: 'grey', href: '/customer-list' },
				{ title: this.$t('customer_information'), color: 'grey', disabled: false },
			];
		},
		recentCustomerHistories() {
			// Assuming createdAt is a date string that needs to be parsed as a date object
			// Sort by date in descending order and then slice the first four
			return this.customerIncidents
				.slice() // create a copy to avoid mutating the original array
				.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)) // sort descending
				.slice(0, 5) // get the first four items
		},

		paginatedStatusHistories() {
			const start = (this.currentPage - 1) * this.itemsPerPage
			const end = start + this.itemsPerPage
			return this.customerIncidents.slice(start, end)
		},
		totalStatusPage() {
			return Math.ceil(this.customerIncidents.length / this.itemsPerPage)
		},
	},
	methods: {
		async updateCustomerProfile(updateObj) {
			let customerDetail = updateObj.customerDetail
			await customerInfo
				.updateCustomerProfile(
					updateObj.id,
					customerDetail /** send the payload */,
					updateObj.pictureUrl
				)
				.then(() => {
					this.snackbar = true
					setTimeout(() => {
						location.reload()
					}, 1000)
				})
				.catch((err) => {
					console.log(err)
				})
		},
		formatDate(dateString) {
			return moment(dateString).format('D MMM YYYY')
		},
		getAssignedAgent(customerHistory) {
			return customerHistory.applications.find(
				(application) => application.Application.approved === true
			)
		},
		async singleCustomerList(id) {
			await customerInfo
				.getSingleCustomerInformation(id)
				.then((response) => {
					if (response.status == 200) {
						let formattedDate = moment(
							response.data.data.updatedAt
						).format('D MMMM YYYY')
						this.customerDetail = {
							...response.data.data,
							updatedAt: formattedDate,
						}
						this.customerIncidents = response.data.data.incidents
					}
				})
		},
	},
}
</script>
